export const RUNNING_ORDER_STATUS = {
  id: 'running-order-id',
  closeOut: 'running-order-close-out',
  addMore: 'running-order-add-more'
};
